import React, { useState, useEffect, useRef } from "react";
import pncil from "../assets/pncil.svg";
import {
  handleError,
  handleSuccessSession,
  validateMobileplus,
} from "../CommonJquery/CommonJquery";

import {
  save_onboarding,
  get_last_resturant,
  server_post_data,
  save_subscription,
} from "../ServiceConnection/serviceconnection";

import { useLocation, useNavigate } from "react-router-dom";
let default_restaurant_id_staff = "0";
const Onboadingstep6 = ({ resnewid,nextStep, prevStep, handlePrevStepcustom }) => {
  const locationdata = useLocation();
    const navigate = useNavigate();
  const searchParams = new URLSearchParams(locationdata.search);
  const subId = searchParams.get("sub_id"); // Extracts 'sub_id'
  const start_date = searchParams.get("start_date"); // Extracts 'sub_id'
  const cus_id = searchParams.get("cus_id"); // Extracts 'sub_id'
  default_restaurant_id_staff = resnewid;
  const [showLoader, setshowLoader] = useState(false);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [restaurantData, setrestaurantData] = useState([]);
  const [activeSection, setActiveSection] = useState("about");
  const [activeEdit, setactiveEdit] = useState("about");
  const [restaurantName, setRestaurantName] = useState("");
  const [additionalInfo, setAdditionalInfo] = useState("");
  const [PerDayMaximum, setPerDayMaximum] = useState("");
  const [ApprovalPersonLimit, setApprovalPersonLimit] = useState("");
  const [BeforeBookingMin, setBeforeBookingMin] = useState("");
  const [TableTurnover, setTableTurnover] = useState("");
  const [RestaurantPrice, setRestaurantPrice] = useState("");
  const [selectedOption, setSelectedOption] = useState(null); // Single value for radio selection
  const [fssaiNumber, setFssaiNumber] = useState("");
  const [gstinNumber, setGstinNumber] = useState("");
  const [cuisines, setCuisines] = useState("");
  const location = useLocation();
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [address, setAddress] = useState({
    location: "",
    street: "",
    country: "",
    city: "",
    state: "",
    zip: "",
  });
  const [contactInfo, setContactInfo] = useState({
    countryCode: "+91",
    phoneNumber: "",
    email: "",
  });
  const [isEditable, setIsEditable] = useState({
    name: false,
    description: false,
    contactDetails: false,
    location: false,
    features: false,
    ratings: false,
  });
  const restaurantInfo = {
    name: "Restaurant Information",
    description: "Restaurant Description.",

    contactDetails: "Contact Details",

    location: "Location",
    features: "Restaurant Features",

    document: "Document ",
    maxseat: "Per Day Max. Seat ",
    approvelimit: "Approval Person Limit ",
    bookingcut: "Booking Cutoff Time",
    tableturnover: "Table Turn Over Time",

    fssanumber: "FSSAI Number",
    gstinnumber: "GSTIN Number",
  };

  const sections = [
    { id: "about", label: "About" },
    { id: "contact", label: "Contact" },
    { id: "location", label: "Location" },
    { id: "document", label: "Document" },
  ];

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const subscriptionId = urlParams.get("sub_id");
    const customerId = urlParams.get("cus_id");
    const startDate = urlParams.get("start_date");
    const paymentStatus = urlParams.get("status");

    console.log("Subscription ID:", subscriptionId);
    console.log("Customer ID:", customerId);
    console.log("Start Date:", startDate);
    console.log("Payment Status:", paymentStatus);

    // If coming back from Chargebee with subscription details, redirect to success page
    if (subscriptionId && customerId && startDate) {
      const successUrl = `/success?sub_id=${subscriptionId}&cus_id=${customerId}&start_date=${startDate}&status=${paymentStatus || 'success'}`;
      navigate(successUrl);
    }

    setPaymentDetails({ subscriptionId, customerId, startDate, paymentStatus });
  }, [location]);

  const sectionRefs = useRef(sections.map(() => React.createRef()));
  const containerRef = useRef(null);

  const handleEditClick = (field) => {
    setIsEditable((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
    setactiveEdit(field);
    setTimeout(() => {
      const inputField = document.querySelector(`.editable-${field}`);
      if (inputField) {
        inputField.focus();
      }
    }, 0);

    setIsEditing(true);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const sectionId = entry.target.id;
            setActiveSection(sectionId);
          }
        });
      },
      { threshold: 0.5 }
    );

    sectionRefs.current.forEach((ref) => {
      if (ref.current) observer.observe(ref.current);
    });

    return () => {
      sectionRefs.current.forEach((ref) => {
        if (ref.current) observer.unobserve(ref.current);
      });
    };
  }, []);

  const handleSaveChangesdynamic = async () => {
    setshowLoader(true);
    const form_data = new FormData();
    form_data.append("default_restaurant_id_staff_new", default_restaurant_id_staff);
    form_data.append("restaurant_name", restaurantName);
    form_data.append("restaurant_tagline", additionalInfo);
    form_data.append("per_day_maximum", PerDayMaximum);
    form_data.append("approval_person_limit", ApprovalPersonLimit);
    form_data.append("before_booking_min", BeforeBookingMin);
    form_data.append("booking_slot_interval", selectedOption);
    form_data.append("table_turnover", TableTurnover);
    form_data.append("restaurant_price", RestaurantPrice);
    form_data.append("restaurant_mobile_no", contactInfo.phoneNumber);
    form_data.append("restaurant_other_no", contactInfo.phoneNumber);
    form_data.append("restaurant_country_code", contactInfo.countryCode);
    form_data.append("restaurant_email", contactInfo.email);
    form_data.append("restaurant_fssai", fssaiNumber);
    form_data.append("restaurant_gstin", gstinNumber);
    form_data.append("restaurant_full_adrress", address.location);
    form_data.append("restaurant_temorary_adrress", address.street);
    form_data.append("restaurant_city", address.city);
    form_data.append("restaurant_state", address.state);
    form_data.append("restaurant_country", address.country);
    form_data.append("restaurant_zipcode", address.zip);
    form_data.append("step_save", "6");

    await server_post_data(save_onboarding, form_data)
      .then(async (Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          handleSuccessSession(Response.data.message, "/View_Onboading");
          // Chargebee checkout link (replace with your actual link)
          // const chargebeeCheckoutUrl =
          //   "https://triosoft.chargebee.com/hosted_pages/checkout?subscription_items[item_price_id][0]=Uprestro_plan-INR-Weekly&utm_source=cb-app-copy";
          // Test Mode link
          // const chargebeeCheckoutUrl =
          //   "https://triosoft-test.chargebee.com/hosted_pages/checkout?subscription_items[item_price_id][0]=uprestro_superadmin-INR-Weekly&utm_source=cb-app-copy";
          // // Print the Chargebee checkout URL
          // console.log("Chargebee Checkout URL:=====> ", chargebeeCheckoutUrl);
          // // Redirect to Chargebee checkout page
          // window.location.href = chargebeeCheckoutUrl;
        }
        setshowLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setshowLoader(false);
      });
  };

  const saveSubsData = async (data) => {
    console.log(data);
    setshowLoader(true);
    const form_data = new FormData();

    form_data.append("restaurant_id", default_restaurant_id_staff);
    form_data.append("order_id", data);
    form_data.append("subscription_start_date", "");
    form_data.append("transaction_id", "");

    await server_post_data(save_subscription, form_data)
      .then(async (Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          // nextStep();
          console.log("Hello Next Step");
        }
        setshowLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setshowLoader(false);
      });
  };

  const handleInputChange = (e) => {
    setRestaurantName(e.target.value);
  };
  const handleAdditionalInfoChange = (e) => {
    setAdditionalInfo(e.target.value);
  };

  useEffect(() => {
    master_data_get();
  }, []);

  const master_data_get = async () => {
    setshowLoaderAdmin(true);
    const form_data = new FormData();
    form_data.append("default_restaurant_id_staff_new", default_restaurant_id_staff);

    await server_post_data(get_last_resturant, form_data)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          if (Response.data.message.restaurant_data.length > 0) {
            setrestaurantData(Response.data.message.restaurant_data[0]);
            setRestaurantName(
              Response.data.message.restaurant_data[0].restaurant_name
            );
            setAdditionalInfo(
              Response.data.message.restaurant_data[0].restaurant_tagline
            );
            setPerDayMaximum(
              Response.data.message.restaurant_data[0].per_day_maximum
            );
            setApprovalPersonLimit(
              Response.data.message.restaurant_data[0].approval_person_limit
            );
            setBeforeBookingMin(
              Response.data.message.restaurant_data[0].before_booking_min
            );
            setTableTurnover(
              Response.data.message.restaurant_data[0].table_turnover
            );
            setSelectedOption(
              Response.data.message.restaurant_data[0].booking_slot_interval
            );
            setRestaurantPrice(
              Response.data.message.restaurant_data[0].restaurant_price
            );
            setContactInfo({
              countryCode:
                Response.data.message.restaurant_data[0]
                  .restaurant_country_code !== null
                  ? Response.data.message.restaurant_data[0]
                      .restaurant_country_code
                  : "+91",
              phoneNumber:
                Response.data.message.restaurant_data[0]
                  .restaurant_mobile_no === null
                  ? ""
                  : Response.data.message.restaurant_data[0]
                      .restaurant_mobile_no,
              email:
                Response.data.message.restaurant_data[0].restaurant_email ===
                null
                  ? ""
                  : Response.data.message.restaurant_data[0].restaurant_email,
            });
            setFssaiNumber(
              Response.data.message.restaurant_data[0].restaurant_fssai
            );
            setGstinNumber(
              Response.data.message.restaurant_data[0].restaurant_gstin
            );
            setAddress({
              location:
                Response.data.message.restaurant_data[0]
                  .restaurant_full_adrress,
              street:
                Response.data.message.restaurant_data[0]
                  .restaurant_temorary_adrress,
              country:
                Response.data.message.restaurant_data[0].restaurant_country,
              city: Response.data.message.restaurant_data[0].restaurant_city,
              state: Response.data.message.restaurant_data[0].restaurant_state,
              zip: Response.data.message.restaurant_data[0].restaurant_zipcode,
            });
            const cuisinesString = Response.data.message.cuisineselected
              .map((option) => option.cuisine_name)
              .join(",");

            setCuisines(cuisinesString);
          }
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleTabClick = (sectionId, index) => {
    setActiveSection(sectionId);
    sectionRefs.current[index].current.scrollIntoView({
      behavior: "smooth",
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let value_ddd = value;
    if (name === "countryCode") {
      value_ddd = validateMobileplus(value);
    }
    setContactInfo((prev) => ({ ...prev, [name]: value_ddd }));
  };

  const handleMobilevalidation = (e) => {
    const { name, value } = e.target;

    if (name === "phoneNumber" && !/^\d*$/.test(value)) {
      return;
    }

    handleChange(e);
  };

  const handleRadioChange = (index) => {
    setSelectedOption(index); // Update selected option
  };
  const handleFssaiChange = (event) => {
    setFssaiNumber(event.target.value);
  };

  const handleGstinChange = (event) => {
    setGstinNumber(event.target.value);
  };

  const handleChangeAdress = (e) => {
    const { name, value } = e.target;
    setAddress((prev) => ({ ...prev, [name]: value }));
  };
  const [isEditing, setIsEditing] = useState(false);

  const handleSaveData = () => {
    setIsEditing(false);
  };
  const contentMapping = {
    about: (
      <div className="AboutCont">
        <div
          className={`underContent1 ${activeEdit == "name" ? "backCOlor" : ""}`}
        >
          <div className="d-flex align-items-center">
            <p>{restaurantInfo.name}</p>
            <img
              src={pncil}
              alt="pncil"
              onClick={() => handleEditClick("name")}
              style={{ cursor: "pointer" }}
            />
          </div>
          <input
            className="form-control editable-name"
            id="name"
            type="text"
            defaultValue="XYZ Restaurant name"
            value={restaurantName}
            onChange={handleInputChange}
            disabled={!isEditable.name}
          />
        </div>
        <div className="underContent">
          <div className="d-flex align-items-center">
            <p>{restaurantInfo.description}</p>
            <img
              src={pncil}
              alt="pncil"
              onClick={() => handleEditClick("description")}
              style={{ cursor: "pointer" }}
            />
          </div>
          <input
            className="form-control editable-description"
            type="text"
            value={additionalInfo}
            onChange={handleAdditionalInfoChange}
            disabled={!isEditable.description}
          />
        </div>
      </div>
    ),
    contact: (
      <div className="contactUs">
        <div className="underContent">
          <div className="d-flex align-items-center">
            <p>{restaurantInfo.contactDetails}</p>
            <img
              src={pncil}
              alt="pncil"
              onClick={() => handleEditClick("contactDetails")}
              style={{ cursor: "pointer" }}
            />
          </div>
          <input
            className="form-control editable-contactDetails"
            type="text"
            value={contactInfo.phoneNumber}
            onChange={handleMobilevalidation}
            disabled={!isEditable.contactDetails}
          />
        </div>
      </div>
    ),
    location: (
      <div className="contactUs">
        <div className="underContent">
          <div className="d-flex align-items-center">
            <p>{restaurantInfo.location}</p>
            <img
              src={pncil}
              alt="pncil"
              onClick={() => handleEditClick("location")}
              style={{ cursor: "pointer" }}
            />
          </div>
          <input
            className="form-control editable-location"
            type="text"
            value={address.location}
            onChange={handleChangeAdress}
            disabled={!isEditable.location}
          />
        </div>
      </div>
    ),

    document: (
      <div className="contactUs">
        <div className="underContent">
          <div className="d-flex align-items-center">
            <p>{restaurantInfo.fssanumber}</p>
            <img
              src={pncil}
              alt="pncil"
              onClick={() => handleEditClick("fssanumber")}
              style={{ cursor: "pointer" }}
            />
          </div>
          <input
            className="form-control editable-fssanumber"
            type="text"
            defaultValue="Fssai Number"
            onChange={handleFssaiChange}
            value={fssaiNumber}
            disabled={!isEditable.fssanumber}
          />
        </div>
        <div className="underContent">
          <div className="d-flex align-items-center">
            <p>{restaurantInfo.gstinnumber}</p>
            <img
              src={pncil}
              alt="pncil"
              onClick={() => handleEditClick("gstinnumber")}
              style={{ cursor: "pointer" }}
            />
          </div>
          <input
            className="form-control editable-gstinnumber"
            type="text"
            onChange={handleGstinChange}
            value={gstinNumber}
            defaultValue="GSTIN Number"
            disabled={!isEditable.gstinnumber}
          />
        </div>
      </div>
    ),
  };

  return (
    <>
      <div className="overflowHeight12">
        <div className="contFOrm">
          <h2 className="headingResto">Restaurant Information</h2>
          <div className="section-buttons">
            {sections.map((section, index) => (
              <button
                key={section.id}
                onClick={() => handleTabClick(section.id, index)}
                className={`section-button ${
                  activeSection === section.id ? "active" : ""
                }`}
              >
                {section.label}
              </button>
            ))}
          </div>
          <div
            ref={containerRef}
            className="content-container"
            style={{ overflowY: "scroll" }}
          >
            {sections.map((section, index) => (
              <div
                key={section.id}
                ref={sectionRefs.current[index]}
                id={section.id}
                className="content-box"
              >
                {contentMapping[section.id]}
              </div>
            ))}
          </div>
        </div>
        <div className="footerbtttn Subbbtn">
          <button
            className={`SvBtn ${isEditing ? "editingClass" : ""}`}
            onClick={isEditing ? handleSaveData : null}
            style={{
              opacity: isEditing ? 1 : 0.5,
              cursor: isEditing ? "pointer" : "not-allowed",
            }}
            disabled={!isEditing}
          >
            Save
          </button>

          <button
            className="SubmtBtN"
            onClick={() => handleSaveChangesdynamic()}
          >
            Submit
          </button>
        </div>
      </div>
    </>
  );
};

export default Onboadingstep6;
